import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import CustomModal from "../../../../app/common-components/CustomModal";
import Spinners from "../../../../app/common-components/Spinner";
import { effciencyApi } from "../../../../app/services/efficiencyApi";
import { ProjectContext } from "./Projects";




const ProjectDeleteModal = ({tablerecall}) => {
  const context = useContext(ProjectContext);
  
  const {  userName } = useSelector((state) => state.common.loggedUser);
  const [deleteLoader, setDeleteLoader] = useState(false);

  const [deleteProject] = effciencyApi.useDeleteProjectMutation();

  const handleClose = () => {
    context.setProjectState((state) => ({
      ...state,
      deleteModalOpen: false,
    }));
  };

  const handleDelete = () => {
    deleteProject({id: context.projectState.projectId,userName}).unwrap(setDeleteLoader(true)).then((data) => {
      if(data.statusCodeValue === 200) {
        context.setProjectState((state) => ({
          ...state,
          deleteModalOpen: false,
          loadPage: !state.loadPage,
          alert: true,
          alertType: "success",
          alertMessage: data?.body,
        }));
        tablerecall();
        setDeleteLoader(false);
      } else if(data.statusCodeValue === 400) {
        context.setProjectState((state) => ({
          ...state,
          deleteModalOpen: false,
          loadPage: !state.loadPage,
          alert: true,
          alertType: "error",
          alertMessage: data?.body,
        }));
        tablerecall();
        setDeleteLoader(false);
      }
      });
  };

  const modalBody = () => (
    <>
    {deleteLoader ? (<Spinners /> ) : (
    <div className="modal-body">
      <h4 className="delete-h">Delete Project</h4>
      <p>Project cannot be deleted. It will be inactive</p>
      <p>User permission will be revoked</p>
      <div className="btnswrap">
        <button
              className="cancelBtnStyle btn btn-primary"
              data-testid="cancelBtn"
              onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </button>
        <button
                className="btnStyle btn btn-primary"
                data-testid="deleteConfirmBtn"  
                onClick={() => {
            handleDelete();
          }}
        >
          Delete
        </button>
      </div>
    </div>
    )}
    </>
  );

  return (
    <CustomModal
      modalOpen={context.projectState.deleteModalOpen}
      modalHide={handleClose}
      modalBody={modalBody}
    />
  );
};

export default ProjectDeleteModal;
